/* eslint-disable require-jsdoc */
import WebApi from './WebApi';
import {EnvService} from '.';

export class AutoCapturaService {
  static async postDadosPessoaisPreAdicionar(data) {
    const url = EnvService.get('Api_DadosPessoaisPreAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postDadosPessoaisAdicionar(data) {
    const url = EnvService.get('Api_DadosPessoaisAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postDadosDocumentoAdicionar(data) {
    const url = EnvService.get('Api_DadosDocumentoAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postEnderecoAdicionar(data) {
    const url = EnvService.get('Api_EnderecoAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postValidarCodigoAcesso(data) {
    const url = EnvService.get('Api_ValidarCodigoAcesso');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async getPortadorSituacao(data) {
    const url = EnvService.get('Api_PortadorSituacao').replace('{chave}', data);

    const response = await WebApi.get(url);
    return response;
  }

  static async postProfissaoAdicionar(data) {
    const url = EnvService.get('Api_ProfissaoAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postProcessarAutorizacao(data) {
    const url = EnvService.get('Api_ProcessarAutorizacao');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postReenviarAssinatura(data) {
    const url = EnvService.get('Api_ReenviarAssinatura');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postDocumentoFrente(data) {
    const url = EnvService.get('Api_DocumentoFrente');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postDocumentoVerso(data) {
    const url = EnvService.get('Api_DocumentoVerso');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postBiometriaAdicionar(data) {
    const url = EnvService.get('Api_BiometriaAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postAdicionarCartao(data) {
    const url = EnvService.get('Api_CartaoAdicionar');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postAdicionarCartoesAdicionais(data) {
    const url = EnvService.get('Api_CartoesAdicionais');

    const response = await WebApi.post(url, data);
    return response;
  }

  static async postBuscaCep(data) {
    const url = EnvService.get('Api_BuscaCep');

    const response = await WebApi.post(url, data);
    return response.data;
  }

  static async postSolicitarCodigoViaSms(dados) {
    const url = EnvService.get('Api_SolicitarCodigoViaSms');

    const response = await WebApi.post(url, dados);
    return response.data;
  }

  static async postValidarCodigoViaSms(dados) {
    const url = EnvService.get('Api_ValidarCodigoViaSms');

    const response = await WebApi.post(url, dados);
    return response.data;
  }

  static async postAssinaturaContrato(dados) {
    const url = EnvService.get('Api_AssinaturaContrato');

    const response = await WebApi.post(url, dados);
    return response.data;
  }

  static async postPreAvaliacaoSolicitar(dados) {
    const url = EnvService.get('Api_PreAvaliacaoSolicitar');

    const response = await WebApi.post(url, dados);
    return response.data;
  }

  static async postAdicionarSeguroContratado(chave, dados) {
    const url = EnvService.get('Api_AdicionarSeguroContratado') + chave;

    const response = await WebApi.post(url, dados);
    return response.data;
  }

  static async getPreAvaliacaoObter(data) {
    const url = EnvService.get('Api_PreAvaliacaoObter').replace(
      '{chave}',
      data,
    );

    const response = await WebApi.get(url);
    return response;
  }

  static async getAppKeyLiveness(data) {
    const url = EnvService.get('Api_GerarAppKeyLiveness');

    const response = await WebApi.post(url, data);
    return response.data;
  }

  static async postLogLivenessResult(data) {
    const url = EnvService.get('Api_LogLivenessResult');

    const response = await WebApi.post(url, data);
    return response.data;
  }

  static getLivenessSettings() {
    const user = EnvService.get('LIVENESS_USER');
    const pass = EnvService.get('LIVENESS_PASS');
    const url = EnvService.get('LIVENESS_URL');

    return {user, pass, url};
  }

  /*
   * UTILIZADO PARA FAZER CONSULTAR EM ARQUIVOS FISICOS JSON
   */
  static async getDefaultFetchJson(url) {
    const response = await fetch(url);
    return await response.json();
  }

  static async getEstadoCivil() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarEstadoCivil'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/estado-civil.txt');
  }

  static async getUfs() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarUfs'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/uf.txt');
  }

  static async getProfissao() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarProfissoes'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/profissao.txt');
  }

  static async getRelacao() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarRelacoes'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/profissao.txt');
  }

  static async getTipoProfissao() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarTipoProfissoes'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/tipo-de-profissao.txt');
  }

  static async getOrgaosExpedidores() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarOrgaosExpedidores'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/orgao-expedidor.txt');
  }

  static async getCidades() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarCidades'),
    );
    // return await AutoCapturaService.getDefaultFetchJson('/json/cidade.txt');
  }

  static async getNacionalidades() {
    return await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarNacionalidades'),
    );
  }

  static async getDiaDeVencimento() {
    const todosDiasVencimento = await AutoCapturaService.getDefaultFetchJson(
      EnvService.get('Api_BuscarDiaDeVencimento'),
    );

    var date = new Date(),
      day = date.getDate();

    return todosDiasVencimento.find((item) => item.dia === day).opcoes;
  }

  static async getParametroSistema(data) {
    const url = EnvService.get('Api_BuscarParametroSistema');

    const response = await WebApi.post(url, data);
    return response.data;
  }

  static async getConsultarTermosUso(data) {
    const url = EnvService.get('Api_ConsultarTermosUso');

    const response = await WebApi.get(url + data.chave);
    return response.data;
  }

  static async getBuscarSeguros(chave) {
    const url = EnvService.get('Api_BuscarSeguros');

    const response = await WebApi.get(url + chave);
    return response.data;
  }
}
